import { useDispatch, useMachineState } from '../app/context';
import { Button } from '../components/Button';
import { cx } from '../components/cx';
import { HazardFrame } from '../components/HazardFrame';
import { ProgressRing } from '../components/ProgressRing';
import { TIMING } from '../domain/timing';
import common from './common.module.css';
import styles from './CountdownScreen.module.css';

export function CountdownScreen() {
  const { countdownRemaining } = useMachineState();
  const dispatch = useDispatch();
  const seconds = Math.max(0, Math.ceil(countdownRemaining));

  return (
    <section className={cx(common.screen, styles.screen)} aria-label="Pre-emission countdown">
      <HazardFrame tone="warning" />
      <h2 className={styles.warning} role="alert">
        LEAVE THE ROOM NOW
      </h2>
      <div className={styles.instruction}>
        The machine is about to start. Take this tablet, go outside, and close the door behind you.
      </div>
      <ProgressRing
        className={styles.ring}
        size={360}
        radius={160}
        strokeWidth={10}
        fraction={countdownRemaining / TIMING.countdown}
        tone="warning"
      >
        <div className={styles.seconds} role="timer" aria-label={`${seconds} seconds left`}>
          {seconds}
        </div>
        <div className={styles.unit}>SECONDS LEFT</div>
      </ProgressRing>
      <Button variant="secondary" size="md" onClick={() => dispatch({ type: 'CANCEL_COUNTDOWN' })}>
        STOP COUNTDOWN
      </Button>
    </section>
  );
}
